import service from '@/services/cliente/categoria'

const getDefaultState = () => ({
  categoria: {
    nombre: '',
    color: 'default',
    descripcion: '',
    esPorcentual: true,
    valor: 0
  },
  list: [],
  currentRow: null,
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LIST: (state, obj) => {
    state.list = obj
  },
  SET_CATEGORIA: (state, obj) => {
    state.categoria = obj
    state.saved = true
  },
  // ADD_CATEGORIA_CLIENTE: (state, obj) => {
  //   state.categoria = obj
  //   state.saved = true
  // },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))
  },
  RESET: (state, { identificacionDef }) => {
    state.categoria = { ...getDefaultState().categoria }
  },
  DELETE_LIST: (state, obj) => {
    state.list = state.list.filter(e => e._id !== obj._id)
  },
  SAVE_CHANGES: (state, obj) => {
    state.categoria = obj
    state.saved = false
  }
}
export const actions = {
  resetList: ({ state }) => {
    state.list = []
  },
  readAllByEmisor: async ({ commit, state, rootGetters, dispatch }, { restart, filter } = { restart: true, filter: null }) => {
    if (restart) await dispatch('resetList')

    if (state.list.length > 0) {
      console.log('Categorias from cache ⏩')
      return true
    }

    console.log('Categorias from DB 😅')
    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], filter).then(response => commit('SET_LIST', response))
  },

  readById: async ({ state, commit }, { _id, refresh = false }) => {
    return service.readById(_id).then(response => {
      return commit('SET_CATEGORIA', response)
    })
  },

  create: async ({ commit, rootGetters }, { input }) => {
    return service
      .create({
        ...input,
        valor: Number(input.valor),
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => commit('UPDATE_LIST', { ...input, _id: result._id }))
  },

  delete: ({ commit }, { inputs }) =>
    service.delete(inputs).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', i)
      })
      return result
    })
}

export const getters = {
  get: state => _id => {
    return state.list.find(e => e._id === _id)
  }
}
